<template>
    <div id="measurement_unit_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="measurementUnitHeader" v-if="$route.params.id > 0">Update Measurement Unit</span>
                    <span class="page-title" id="measurementUnitHeader" v-else>Add Measurement Unit</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="backMeasurementUnitList">
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content measurement-unit-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="measurementUnitForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Name:</label>
                                        <input type="text" class="form-control" v-model="name" id="name" placeholder="Enter Name" name="name">
                                        <div class="field-error">{{name_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="symbol">Symbol:</label>
                                        <input type="text" class="form-control" v-model="symbol" id="symbol" placeholder="Enter Symbol" name="symbol">
                                        <div class="field-error">{{symbol_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="description">Description:</label>
                                        <input type="text" class="form-control" v-model="description" id="description" placeholder="Enter Description" name="description">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createMeasurementUnitBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateMeasurementUnit" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="createMeasurementUnitBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateMeasurementUnit" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueMeasurementUnitBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateMeasurementUnit(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelMeasurementUnitBtn" class="btn btn-tertiary" v-on:click.prevent="backMeasurementUnitList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
    import Vue from "vue";
    
    import {commonMixins} from '../mixins/commonMixins';
    
    
    
    export default {
        name: "measurement_unit_create",
        metaInfo() {
            return {title: (this.$route.params.id > 0)? "Update Measurement Unit | " +process.env.COPYRIGHT_NAME : "Create Measurement Unit | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins],
        data: () => ({
             permissions: [],
            cantAccessPage: "",
            name: "",
            symbol: "",
            description:"",
            loading:false,
            name_error_msg: "",
            symbol_error_msg:""
        }),
        watch:{
            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'add_measurement_unit') {
                            self.cantAccessPage = true;
                        }
                    }
                }

            }
        },
        created: function() {

        },
        mounted: function() {
            var self = this;
            self.getPermissions();
            setTimeout(function () {
                var path = window.location.pathname;
                var segments = path.split("/");

                if (segments[3]) {
                    self.loadMeasurementUnit();
                }
            }, 100);
        },
        methods: {

            backMeasurementUnitList() {
                var self = this;
                self.$router.push("/measurementunit/list");
            },

            CreateMeasurementUnit(flag) {

                var self = this;

                self.name_error_msg = "";
                self.symbol_error_msg = "";

                self.symbol = self.symbol.trim();
                self.name = self.name.trim();

                if (!self.name || self.name == null || self.name == "") {
                    self.name_error_msg = "Name Required.";
                }

                if (!self.symbol || self.symbol == null || self.symbol == "") {
                    self.symbol_error_msg = "Symbol Required.";
                }

                if (self.name_error_msg == "" && self.symbol_error_msg == "") {
                        self.loading = true;
                        var path = window.location.pathname;
                        var segments = path.split("/");
                        if (segments[3])
                        {
                            $("#createMeasurementUnitBtn").val("Updating ...");
                            $("#createAndContinueMeasurementUnitBtn").prop("disabled", true);
                            $("#cancelMeasurementUnitBtn").prop("disabled",true);
                        } else {
                            if (flag == "Save and Continue") {

                                $("#createAndContinueMeasurementUnitBtn").val("Saving ...");
                                $("#createMeasurementUnitBtn").prop("disabled", true);
                                $("#createAndContinueMeasurementUnitBtn").prop("disabled", true);
                                $("#cancelMeasurementUnitBtn").prop("disabled",true);

                            }else{

                                $("#createMeasurementUnitBtn").val("Saving ...");
                                $("#createMeasurementUnitBtn").prop("disabled", true);
                                $("#createAndContinueMeasurementUnitBtn").prop("disabled", true);
                                $("#cancelMeasurementUnitBtn").prop("disabled",true);
                            }

                        }

                        $.ajax({
                            url: process.env.ROOT_API + "/measurementunit/create",
                            type: "POST",
                            data: {name: self.name,id: segments[3], symbol: self.symbol,description: self.description},
                            headers: this.ajxHeaders,
                            dataType: "json",
                            success: function (data) {
                                self.loading = false;
                                if (segments[3])
                                {
                                    $("#createMeasurementUnitBtn").val("Update");
                                    $("#createMeasurementUnitBtn").prop("disabled", false);
                                    $("#cancelMeasurementUnitBtn").prop("disabled",false);

                                } else {

                                    if (flag == "Save and Continue") {
                                        $("#createAndContinueMeasurementUnitBtn").val("Save and Continue");
                                        $("#createMeasurementUnitBtn").prop("disabled", false);
                                        $("#createAndContinueMeasurementUnitBtn").prop("disabled", false);
                                        $("#cancelMeasurementUnitBtn").prop("disabled",false);
                                    } else {
                                        $("#createMeasurementUnitBtn").val("Save");
                                        $("#createMeasurementUnitBtn").prop("disabled", false);
                                        $("#createAndContinueMeasurementUnitBtn").prop("disabled", false);
                                        $("#cancelMeasurementUnitBtn").prop("disabled",false);
                                    }

                                }
                                if (data.status == "success") {

                                    if (flag == "Save and Continue") {

                                        self.name = "";
                                        self.symbol = "";
                                        self.description = "";

                                    }else{
                                        self.$router.push("/measurementunit/list");
                                    }

                                } else {

                                    if (data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < data.content.length; i++) {
                                            err += data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-warning").toggleClass("show");
                                        setTimeout(function () {
                                            $(".alert-warning").removeClass("show");
                                            $(".alert-warning").addClass("hide");
                                        }, 10000);
                                    }
                                }
                            },
                            error: function (jqXHR, exception) {
                                self.loading = false;
                                if (segments[3])
                                {
                                    $("#createMeasurementUnitBtn").val("Update");
                                    $("#createMeasurementUnitBtn").prop("disabled", false);
                                    $("#cancelMeasurementUnitBtn").prop("disabled",false);
                                } else {

                                    if (flag == "Save and Continue") {
                                        $("#createAndContinueMeasurementUnitBtn").val("Save and Continue");
                                    } else {
                                        $("#createMeasurementUnitBtn").val("Save");
                                    }

                                    $("#createMeasurementUnitBtn").prop("disabled", false);
                                    $("#createAndContinueMeasurementUnitBtn").prop("disabled", false);
                                    $("#cancelMeasurementUnitBtn").prop("disabled",false);

                                }

                                self.generateStatusCodeMessage(jqXHR,true,'measurement-create')
                            }
                        });
                }else{
                    self.errorValidationFocus();
                }

                  
            },

            loadMeasurementUnit() {

                var path = window.location.pathname;
                var segments = path.split("/");
                var self = this;
                self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/measurementunit/" + segments[3],
                    type: "GET",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;

                        if (data.status == "success") {
                            self.name = data.content.name;
                            self.symbol = data.content.symbol;
                            self.description = data.content.description;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'measurement-by-id')
                    }
                });
            },
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/MeasurementUnitCreate.vue